<template>
  <div :class="classList">
    <slot></slot>
  </div>
</template>

<script lang="ts">
  import Vue from 'vue';
  import sizeable from '../../mixins/sizeable/sizeable';
  import mixins from '../../mixins';

  const justifyItems = [
    'center',
    'start',
    'end',
    'left',
    'right',
    'space-between',
    'space-around',
    'space-evenly',
  ];

  const alignItems = [
    'center',
    'start',
    'end',
    'stretch',
    'baseline',
  ];

  // const alignContent = [
  //   'center',
  //   'start',
  //   'end',
  //   'stretch',
  //   'space-between',
  //   'space-around',
  //   'space-evenly',
  // ];

  const justifyProps = {} as Record<string, any>;
  justifyItems.forEach((value) => {
    justifyProps[`justify-${value}`] = { default: false, type: Boolean };
  });

  const alignItemsProps = {} as Record<string, any>;
  alignItems.forEach((value: any) => {
    alignItemsProps[`align-${value}`] = { default: false, type: Boolean };
  });

  // const alignContentProps = {};
  // alignContent.forEach((value) => {
  //   alignContentProps[`align-content-${value}`] = { default: false, type: Boolean };
  // });

  export default mixins(sizeable).extend({
    mixins: [sizeable],
    props: {
      column: { type: Boolean, default: false },
      nowrap: { type: Boolean, default: false },
      fillHeight: { type: Boolean, default: false },
      noGutters: { type: Boolean, default: false },
      reverse: { type: Boolean, default: false },
      grow: { type: Boolean, default: false },
      shrink: { type: Boolean, default: false },
      ...justifyProps,
      ...alignItemsProps,
      // ...alignContentProps,
    },
    computed: {
      classList(): Record<string, boolean> {
        return {
          'p-row': true,
          row: true,
          nowrap: this.nowrap,
          dense: this.dense,
          spacious: this.spacious,
          column: this.column,
          reverse: this.reverse && !this.column,
          'reverse-column': this.reverse && this.column,
          'no-gutters': this.noGutters,
          'fill-height': this.fillHeight,
          ...this.getClassListFromValues(justifyProps),
          ...this.getClassListFromValues(alignItemsProps),
          // ...this.getClassListFromValues(alignContentProps),
        };
      },
    },
    methods: {
      getClassListFromValues(values: Record<string, any>) {
        return Object.keys(values).reduce((result, name) => {
          const parsedName = name.replace(/([-_][a-z])/ig, ($1) => {
            return $1.toUpperCase()
              .replace('-', '')
              .replace('_', '');
          });
          return { ...result, [name]: this.$props[parsedName] };
        }, {});
      },
    },
  });
</script>
